import { render, staticRenderFns } from "./SplitLayout.vue?vue&type=template&id=21b5ca60&scoped=true&"
import script from "./SplitLayout.vue?vue&type=script&lang=js&"
export * from "./SplitLayout.vue?vue&type=script&lang=js&"
import style0 from "./SplitLayout.vue?vue&type=style&index=0&id=21b5ca60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b5ca60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VImg,VNavigationDrawer,VRow})
